var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('p',{staticClass:"text-label-1 text-orange-500 font-medium mt-4px",class:{ 'pl-100px': _vm.inline },domProps:{"innerHTML":_vm._s(_vm.getError())}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }